"use strict";

window._theme = window._theme || {};

class LocationValidator {
  #variantsKey = '_variants';

  constructor() {
    this.state = {
      variantLocations: {},
      jtcProductInventoryInfo: null,
      cart: null,
      useCachedCart: false,
      isVariantUpdating: false,
      forceShowLoading: false,
      cartAttributes: _theme.cartjson.attributes,
      userPincode: JSON.parse(localStorage.getItem('pincodeData'))
    };

    // document.addEventListener("DOMContentLoaded", (event) => {
    //   // const productActionContainers = document.querySelectorAll('.product-icon-action');
    //   // if(productActionContainers.length) this.state.forceShowLoading = true;
    //   // productActionContainers.forEach(container => {
    //   //   const icon = document.createElement('span');
    //   //   icon.classList.add('icon-loading');
    //   //   icon.innerHTML = `<i class="enj-loader-add-to-cart fsz-unset"><svg xml:space="preserve" style="enable-background:new 0 0 50 50;margin-top: -1px;" viewBox="0 0 24 30" height="20px" width="21px" y="0px" x="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg" id="Layer_1" version="1.1"><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="0"><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="8">      <animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.15s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect><rect opacity="0.2" fill="#fff" height="8" width="3" y="10" x="16"><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="0.2; 1; .2" attributeType="XML" attributeName="opacity"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 20; 10" attributeType="XML" attributeName="height"/><animate repeatCount="indefinite" dur="0.6s" begin="0.3s" values="10; 5; 10" attributeType="XML" attributeName="y"/></rect></svg></i>`;
    //   //   container.appendChild(icon);
    //   // });

    //   // const stockNoticeElem = document.querySelector('.detail-info .limited-stock');
    //   // if(stockNoticeElem) stockNoticeElem.classList.add('loading');
    //   // this.showLoading();
    //   // this.initEvents();
    // });

    // window.onbeforeunload = () => {
    //   this.removeEvents();
    // }

    // document.addEventListener("tomitLoaded", async () => {
    //   this.toggleQuickview();
    //   await this.validateAndUpdateCart();
    //   if(this.current_v) await this.updateVariantStockText(this.current_v);
    //   this.hideLoading();
    //   this.state.jtcProductInventoryInfo = window.jtcProductInventoryInfo;
    // });
  }

  set currentVariant(variant){
    this.current_v = variant || null;
  }

  init() {
    this.initDOMSelectors();
    this.cartPincodeValidator();
  }

  async cartPincodeValidator() {
    if(!this.state.cartAttributes._pincode && this.state.userPincode && this.state.userPincode.pincode) {
      await this.updateCartPincode(this.state.userPincode.pincode, true);
      window.location.reload();
    }

    if(!this.state.cartAttributes._pincode && !this.state.userPincode) {
      setTimeout(() => {
        this.showLocationModal();
      }, _theme.pincodeValidation.modalDelayTime);
    }
  }

  toggleQuickview = async () => {
    const productCards = document.querySelectorAll('.product-location-collection-page');
    if(productCards.length === 0) {
      this.state.forceShowLoading = false;
      return;
    }
    
    const validateCardQuickview = async (cards) => {
      const card = cards.shift();
      if(!card) return;

      const parent = card.closest('[class*=product-item-]') || card.parentElement;
      const variants = card.dataset.variants;
      if(!parent || !variants) return;

      let notAvailable = parent.querySelector('.product-icon-action .hp-not-available');
      if(!notAvailable) notAvailable = parent.querySelector('.product-icon-action .not-available');
      const quickviewParent = parent.querySelector('.product-icon-action .quick-view.mr-0');
      const quickview = parent.querySelector('.product-icon-action .engoj_btn_quickview');
      let hasNotAvailable = notAvailable ? true : false;
      let hasNotQuicview = quickviewParent ? true : quickview ? true : false;
      if(!hasNotAvailable || !hasNotQuicview) return;
  
      const variantIds = variants?.split(',') || [];
      let count = 0;
      
      const validateQty = async (items) => {
        const variant_id = items.shift();
        if(variant_id){
          const supplyLocation = await this.getVariantStock(variant_id);
          if(supplyLocation && supplyLocation.stock > 0) count++;
        }
        if(count === 0 && items.length > 0) return await validateQty(items);
        return true;
      }
      
      if(variantIds.length) await validateQty(variantIds);

      if(count > 0){
        notAvailable && (notAvailable.style.display = 'none');
        quickviewParent && (quickviewParent.style.display = 'block');
        quickview && (quickview.style.display = 'block');
      } else {
        notAvailable && (notAvailable.style.display = 'block');
        quickviewParent && (quickviewParent.style.display = 'none');
        quickview && (quickview.style.display = 'none');
      }

      parent && parent.classList.add('script-loaded');

      if(cards.length > 0) return await validateCardQuickview(cards)
      return true;
    }

    await validateCardQuickview(Array.from(productCards));
    this.state.forceShowLoading = false;
    this.hideLoading();
  }

  updateVariantStockText = async (variant, qtyInputSelectors, productHandle) => {
    // if(!window.jtcProductInventoryInfo || this.state.isVariantUpdating) return;
    if(!variant) return;
    let finalVariant;

    if(_theme.product_variants) {
      finalVariant = _theme.product_variants.find(v => v.variant_id === variant.id);
    } else {
      if(productHandle) {
        const supplyLocation = await this.fetchVariantData(productHandle, variant.id);
        if(supplyLocation) finalVariant = {inventory_quantity: supplyLocation.stock};
      }
    }

    if(!finalVariant) return;

    if(qtyInputSelectors && qtyInputSelectors.length > 0) {
      qtyInputSelectors.forEach(inputNode => {
        const inputValue = Number(inputNode.value);
        if(inputValue > finalVariant.inventory_quantity) {
          inputNode.value = finalVariant.inventory_quantity;
        }
      });
    }

    let supplyLocation = {stock: finalVariant.inventory_quantity};
    this.state.isVariantUpdating = true;
    const stockNoticeElems = document.querySelectorAll('.limited-stock');
    const atcBtnBlocks = document.querySelectorAll('#AddToCartForm .detail-attr button, #AddToCartForm .shopify-payment-button button');
    const notAvailable = document.querySelector('#notAvailable');

    atcBtnBlocks.forEach(item => { item.classList.add('atc-error'); });
    notAvailable && (notAvailable.style.display = "none");

    try {
      stockNoticeElems.forEach(stockNoticeElem => {
        stockNoticeElem.classList.add('loading');
      });
      // if(variant) supplyLocation = await this.getVariantStock(variant.id);
      
      // ATC & Buy Now Button
      if(supplyLocation && supplyLocation.stock > 0){
        atcBtnBlocks.forEach(item => { item.classList.remove('atc-error'); });
        notAvailable && (notAvailable.style.display = "none");
      } else {
        atcBtnBlocks.forEach(item => { item.classList.add('atc-error'); });
        notAvailable && (notAvailable.style.display = "block");
      }
      
      // Stock Notice Text
      if(stockNoticeElems.length){
        const notAvailableTxt = document.querySelector('.detail-info #notAvailable');
        const stock = supplyLocation ? supplyLocation.stock : 0;
        let msg = '';
        if (stock === 0) {
          msg = 'Currently Out of Stock.';
        } else if (stock < 20 && stock > 0) {
          msg = `Limited stock! Only ${stock} available. Don’t wait, order now!`;
        } else if (stock > 0) {
          msg = '';
        } else {
          msg = 'Not Available At Your Location';
        }

        stockNoticeElems.forEach(stockNoticeElem => {
          stockNoticeElem.textContent = msg;
        });
        if(notAvailableTxt && (!stock || stock < 1)){
          notAvailableTxt.textContent = 'Not Available At Your Location';
          notAvailableTxt.style.display = 'block';
        }else{
          if(stock < 20 && stock >= 1){
            stockNoticeElems.forEach(stockNoticeElem => {
              stockNoticeElem.classList.add('limited-stock_alertt');
            });
          }else{
            stockNoticeElems.forEach(stockNoticeElem => {
              stockNoticeElem.classList.remove('limited-stock_alertt');
            });
          }
        }

        stockNoticeElems.forEach(stockNoticeElem => {
          stockNoticeElem.classList.remove('loading');
        });
      }

      this.state.isVariantUpdating = false;
    } catch(err){
      this.state.isVariantUpdating = false;
      atcBtnBlocks.forEach(item => { item.classList.remove('atc-error'); });
      console.error('Error while fetching variant warehouse quantity');

      stockNoticeElems.forEach(stockNoticeElem => {
        stockNoticeElem.classList.remove('loading');
      });
    }
  }

  initDOMSelectors = () => {
    this.selectors = {
      toastModal: "[data-toast-notify]",
      toastModalText: "[data-toast-notify] [data-toastmsg]",
      checkoutBtn: "[data-checkout-act]",
      locationModal: document.querySelector('#loactionPopup')
    };
  }

  initEvents = () => {
    // const checkoutBtns = document.querySelectorAll(this.selectors.checkoutBtn);
    // checkoutBtns.forEach(btn => {
    //   btn.removeEventListener('click', this.preCheckoutValidation)
    //   btn.addEventListener('click', this.preCheckoutValidation)
    // });
  }

  removeEvents = () => {
    const checkoutBtns = document.querySelectorAll(this.selectors.checkoutBtn);
    checkoutBtns.forEach(btn => {
      btn.removeEventListener('click', this.preCheckoutValidation)
    });
  }

  preCheckoutValidation = async (evt) => {
    const target =  evt.target;
    const href = target.getAttribute('href');
    if(href === '#') return;
    evt.preventDefault();

    target.classList.add('loading');
    let cart = this.state.useCachedCart && this.state.cart;
    if(!cart) cart = await this.getCart();

    if(cart.item_count === 0) {
      target.classList.remove('loading');
      return;
    }
   
    localStorage.setItem("cartdata", JSON.stringify(cart));
    beginCheckout(cart);
    await this.validateAndUpdateCart();
    target.classList.remove('loading');
    window.location.href = '/checkout'; 
  }

  showLoading = () => {
    document.body.classList.add("validating-location-qty");
  }

  hideLoading = () => {
    if(!this.state.forceShowLoading){
      setTimeout(() => {
        document.body.classList.remove("validating-location-qty");
      }, 500);
    }
  }

  showError = (maxqty) => {
    if (maxqty === undefined || maxqty === null) return;
    let msg = `Only ${maxqty} ${
      maxqty > 1 ? " units " : " unit "
    } of this variant is available for your location`;
    if (maxqty === 0) msg = "This variant is soldout for your location";
    this.showNotification(msg);
    
  }

  showNotification = (msg, autoHide, delay = 3000) => {
    const toastModal = document.querySelector(this.selectors.toastModal);
    if(!toastModal) return;
    const toastModalText = document.querySelector(
      this.selectors.toastModalText
    );
    toastModalText.textContent = msg;
    toastModal.classList.add("active");

    if(autoHide) setTimeout(this.hideNotification, delay);
  }

  hideNotification = () => {
    const toastModal = document.querySelector(this.selectors.toastModal);
    if(!toastModal) return;
    toastModal.classList.remove("active");
  }

  showLocationModal() {
    this.selectors.locationModal.classList.add('show-popup');
  }

  hideLocationModal() {
    if(!this.state.cartAttributes._pincode && !this.state.userPincode) return;
    this.selectors.locationModal.classList.remove('show-popup');
  }

  fetchVariantLocations = async (variantId) => {
    if (!variantId || !window.jtcProductInventoryInfo) return Promise.reject("missing or Invalid variant id");

    try {
      const variantLocations = await jtcProductInventoryInfo.processVariant(
        null,
        variantId
      );

      this.state.variantLocations[variantId] = variantLocations;

      return variantLocations;
    } catch (err) {
      return null;
    }
  }

  updateCart = async (updates) => {
    try {
      const resp = await fetch('/cart/update.js', {
        method: 'post',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates })
      });
      const cart = await resp.json();
      return cart;
    } catch (error) {
      console.error(error);
      return null
    }
  }

  getCart = async () => {
    try {
      const resp = await fetch("/cart.js");
      const cart = await resp.json();
      this.state.cart = cart;

      this.state.useCachedCart = true;
      setTimeout(() => {
        this.state.useCachedCart = false;
      }, 8000);

      return cart;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  validateAndUpdateCart = async (displayError = true) => {
    const result = { status: true, error: [] };
    let cart = this.state.useCachedCart && this.state.cart;
    if(!cart) cart = await this.getCart();
    if(cart.item_count === 0) return result;

    const validateCartQty = async (items) => {
      const { title, variant_id, quantity } = items.shift();
      const data = await this.validateVariantLocationQty(variant_id, quantity);
      if(!data.status) result.error.push({ title, variant_id, stock: data.stock });

      if(items.length > 0) return await validateCartQty(items);
      return true;
    }

    await validateCartQty(cart.items);

    if(result.error.length > 0) result.status = false;
    
    if(!result.status && result.error.length > 0){
      const updates = {};
      result.error.forEach(({ variant_id, stock }) => {
        updates[variant_id] = stock;
      });

      await this.updateCart(updates);
      if(displayError) this.showNotification("Cart validated & updated successfully!", true);
      result.status = true;
      result.error = [];
    }

    return result;
  }

  validateVariantWithCart = async (variantId, maxQty) => {
    const result = { status: true, maxQtyAvailableToBuy: maxQty };
    let cart = this.state.useCachedCart && this.state.cart;
    if(!cart || cart.items) cart = await this.getCart();
    if(cart.item_count === 0) return result;

    const cartTotalVariantQty = cart.items.reduce((acc, item) => {
      const qty = item.variant_id === Number(variantId) ? item.quantity : 0;
      return acc + qty;
    }, 0);

    const maxQtyAvailableToBuy = maxQty - cartTotalVariantQty;
    result.status = maxQtyAvailableToBuy > 0 ? true : false;
    result.maxQtyAvailableToBuy = maxQtyAvailableToBuy;
    return result;
  }

  getVariantStock = async (variantId) => {
    const savedLocation = JSON.parse(localStorage.getItem("pincodeData"));
    
    if (!savedLocation || !variantId || !warehouseData) return null;

    const warehouse = warehouseData.find((wh) => wh.states.includes(savedLocation.state));
    if (!warehouse) return null;
    
    let variantLocations = this.state.variantLocations[variantId];
    if (!variantLocations) variantLocations = await this.fetchVariantLocations(variantId);
    if(!variantLocations) return null;

    const supplyLocation = variantLocations.find((location) => location.id === warehouse.id);
    if (!supplyLocation) return null;

    return supplyLocation;
  }

  // variantId, qty = 1, displayError = false
  validateVariantLocationQty = async (productHandle, variantId, qty = 1, displayError = false) => {
    // if (!window.jtcProductInventoryInfo) return;
    const result = { status: true, stock: 0 };

    try {
      this.showLoading();
      // const supplyLocation = await this.getVariantStock(variantId);
      const supplyLocation = await this.fetchVariantData(productHandle, variantId);
      
      if(!supplyLocation){
        result.status = false;
        result.stock = 0;
        this.hideLoading();
        return result;
      }

      if (supplyLocation.stock <= 0) {
        result.status = false;
        result.stock = supplyLocation.stock;
      }

      if (qty > supplyLocation.stock) {
        result.status = false;
        result.stock = supplyLocation.stock;
        if (displayError) this.showError(supplyLocation.stock);
      } else {this.hideNotification();}

      if(result.status){
        let { status, maxQtyAvailableToBuy } = await this.validateVariantWithCart(variantId, supplyLocation.stock);
        maxQtyAvailableToBuy = maxQtyAvailableToBuy - qty;
        // console.log("maxQtyAvailableToBuy>>>", maxQtyAvailableToBuy);
        if(!status || maxQtyAvailableToBuy < 0){
          result.status = false;
          result.stock = supplyLocation.stock;
          if (displayError) this.showError(supplyLocation.stock);
        } else this.hideNotification();
      }

      this.hideLoading();

      return result;
    } catch (err) {
      this.hideLoading();
      result.failed = true;
      return result;
    }
  }

  getHTMLBody(str){
    if(!str) return null;
  
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    return doc.body;
  }

  async fetchVariantData(productHandle, variantId) {
    if(!productHandle || !variantId) throw new Error("Invalid productHandle or variantId");

    try {
      const resp = await fetch(`/products/${productHandle}?variant=${variantId}&sections=product-json`);
      const result = await resp.json();
      const body = this.getHTMLBody(result['product-json']);
      const data = JSON.parse(body.querySelector('.shopify-section').textContent);

      return {stock: data.current_variant_qty}
    } catch (error) {
      console.log(error.message);
      return null;
    }
  }

  async updateCartPincode(pincode, available) {
    try {
      const resp = await fetch('/cart/update.js', {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "attributes": {
            "_pincode": pincode,
            "_serviceable": available ? true : false
          }
        })
      });

      const cart = await resp.json();
      return cart;
    } catch (error) {
      return null;
    }
  }
}

_theme.locationValidator = new LocationValidator();

document.addEventListener("DOMContentLoaded", (event) => {
  if(_theme.pincodeValidation.enable) _theme.locationValidator.init();
});